export default "__VITE_ASSET__CZJh3RLn__"